import React from 'react';

// This context is meant to contain an Event data type value.
const EventContext = React.createContext(null);

export default EventContext;
